var map = {
	"./papsi_account_number.svg": 9453,
	"./papsi_address.svg": 2621,
	"./papsi_age.svg": 3076,
	"./papsi_apply.svg": 4100,
	"./papsi_arrow_back.svg": 2585,
	"./papsi_arrow_back_alt.svg": 6317,
	"./papsi_arrow_forward.svg": 842,
	"./papsi_avatar.svg": 2518,
	"./papsi_avatar_dark.svg": 4654,
	"./papsi_avatar_light.svg": 2432,
	"./papsi_back.svg": 9002,
	"./papsi_back_dark.svg": 7954,
	"./papsi_ballot.svg": 3446,
	"./papsi_branches.svg": 4721,
	"./papsi_calendar.svg": 9655,
	"./papsi_cancel_circle.svg": 3771,
	"./papsi_check.svg": 9737,
	"./papsi_check_adcom.svg": 1997,
	"./papsi_check_circle.svg": 4189,
	"./papsi_check_circle_filled.svg": 5560,
	"./papsi_check_elecom.svg": 833,
	"./papsi_ck_off.svg": 5254,
	"./papsi_ck_on.svg": 9155,
	"./papsi_company.svg": 823,
	"./papsi_date.svg": 4011,
	"./papsi_date_of_birth.svg": 9635,
	"./papsi_delete.svg": 9026,
	"./papsi_device_mobile.svg": 3387,
	"./papsi_device_tablet.svg": 7754,
	"./papsi_dob.svg": 7930,
	"./papsi_dropdown.svg": 8542,
	"./papsi_dropup.svg": 7215,
	"./papsi_edit.svg": 965,
	"./papsi_edit_white.svg": 8446,
	"./papsi_election.svg": 9757,
	"./papsi_error.svg": 9779,
	"./papsi_events.svg": 6807,
	"./papsi_exit.svg": 4088,
	"./papsi_exit_red.svg": 6719,
	"./papsi_explore.svg": 350,
	"./papsi_gender_female.svg": 308,
	"./papsi_gender_male.svg": 7237,
	"./papsi_handshake.svg": 3767,
	"./papsi_help.svg": 4976,
	"./papsi_help_contact.svg": 3802,
	"./papsi_help_dark.svg": 7138,
	"./papsi_help_forgot.svg": 9580,
	"./papsi_help_privacy.svg": 9313,
	"./papsi_home.svg": 590,
	"./papsi_home_dark.svg": 4556,
	"./papsi_home_grey.svg": 7797,
	"./papsi_info.svg": 5295,
	"./papsi_info_blue.svg": 7895,
	"./papsi_info_green.svg": 8139,
	"./papsi_list.svg": 3935,
	"./papsi_location.svg": 3818,
	"./papsi_logout.svg": 184,
	"./papsi_memdata.svg": 4645,
	"./papsi_memtype.svg": 9771,
	"./papsi_menu.svg": 6148,
	"./papsi_menu_dark.svg": 5738,
	"./papsi_more.svg": 219,
	"./papsi_password_invisible.svg": 7426,
	"./papsi_password_visible.svg": 7942,
	"./papsi_pencil.svg": 6090,
	"./papsi_pin.svg": 9265,
	"./papsi_pnb.png": 961,
	"./papsi_privacy.png": 5770,
	"./papsi_recalculate.svg": 1335,
	"./papsi_registered.svg": 7290,
	"./papsi_reset.svg": 8216,
	"./papsi_selected.svg": 2884,
	"./papsi_serial.svg": 5918,
	"./papsi_services.svg": 5508,
	"./papsi_services_grey.svg": 948,
	"./papsi_setting_auth.svg": 7145,
	"./papsi_setting_deactivate.svg": 6729,
	"./papsi_setting_email.svg": 2856,
	"./papsi_setting_mobile.svg": 6554,
	"./papsi_setting_password.svg": 2327,
	"./papsi_setting_username.svg": 4383,
	"./papsi_settings.svg": 1301,
	"./papsi_settings_dark.svg": 8569,
	"./papsi_snowman.svg": 8594,
	"./papsi_spinner.svg": 451,
	"./papsi_spinner_green.svg": 4830,
	"./papsi_stagger.svg": 1538,
	"./papsi_star_off.svg": 484,
	"./papsi_star_on.svg": 1417,
	"./papsi_status.svg": 4342,
	"./papsi_success.svg": 8903,
	"./papsi_success_green.svg": 9150,
	"./papsi_summary_collapse.svg": 3624,
	"./papsi_tax.svg": 1787,
	"./papsi_transfer.svg": 3832,
	"./papsi_upload_file.svg": 4351,
	"./papsi_vote.svg": 7354,
	"./selected/papsi_selected_audit.svg": 2596,
	"./selected/papsi_selected_bod.svg": 2095,
	"./selected/papsi_selected_elecom.svg": 4287
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6075;